var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTmInn = function SvgTmInn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.325 18.959c-.167 0-.3-.034-.4-.075-.333-.125-.9-.534-.9-1.826v-5.374h-1.95c-1.117 0-1.517-.525-1.658-.834-.142-.316-.267-.958.466-1.8l6.309-7.166c.85-.967 1.541-.9 1.875-.775.333.125.9.533.9 1.825v5.375h1.95c1.117 0 1.516.525 1.658.833.142.317.267.958-.466 1.8L9.8 18.108c-.592.675-1.108.85-1.475.85M11.61 2.284c-.025.033-.2.116-.476.433L4.826 9.884c-.233.266-.267.433-.267.466.017.008.167.092.517.092H7.65a.63.63 0 0 1 .625.625v6c0 .416.075.6.108.65.025-.034.2-.117.475-.433l6.309-7.167c.233-.267.267-.433.267-.467-.017-.008-.167-.091-.517-.091h-2.575a.63.63 0 0 1-.625-.625v-6c.008-.417-.075-.592-.109-.65"
  })));
};
export default SvgTmInn;